import React from 'react';
import _ from 'lodash';

import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
export const HelpTopicBasicInfoComponent = ({
  selectedSocialProfiles,
  handleInnerFormChange,
  helpTopics,
  selectedHelpTopics

}: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Title"
              labelField="Title"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Title'
                );
              }}
              type="text"
              value={selectedHelpTopics?.Title}
            />
            <InputContainer
              label="Parent Topic"
              labelField="Title"
              list={helpTopics}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ParentId'
                );
              }}
              optionName="Choose Parent Topic"
              type="select"
              valueField="Id"
              value={selectedHelpTopics?.ParentId}
            />
            <div className='col-span-full'>
              <InputContainer
                label="Body"
                name="Body"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event,
                    'Body'
                  )
                }}
                type="rte"
                value={selectedHelpTopics?.Body}
              /></div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
    </>
  );
};
export default HelpTopicBasicInfoComponent;
